// PrivacyPolicy.jsx
import React from 'react';
import Image from "../public/ai-generated-assortment-of-african-traditional-dishes-african-food-free-photo.jpg";
import Logo from "../public/AfricFreshLogo-01.svg";
import { Link } from 'react-router-dom';
import Footer from '../components/footer';

const PrivacyPolicy = () => {
  return (
    <div className="w-full min-h-screen flex flex-col">
      {/* Header */}
      <div className='flex justify-center items-center py-5'>
        <Link to="/">
          <img src={Logo} alt="AfricFresh Logo" className='w-[200px]' />
        </Link>
      </div>

      {/* Hero Banner */}
      <div className="relative h-[300px] w-full">
        <div 
          className="absolute inset-0 bg-cover bg-center before:content-[''] before:absolute before:inset-0 before:bg-black before:opacity-50"
          style={{
            backgroundImage: `url(${Image})`,
          }}
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <h1 className="text-white text-5xl md:text-6xl font-serif px-4 text-center">
            Privacy Policy
          </h1>

          <Link to="/">
          <button
                  
                  
                    className="bg-[#007D44] text-white px-4 cursor-pointer py-2 rounded hover:bg-[#F0B241] transition"
                  >
                   hello
                  </button>
          </Link>
        </div>
      </div>

      {/* Content Section */}
      <div className="max-w-4xl mx-auto px-6 py-12 bg-[#fdf7f7] flex-grow">
        <h2 className="text-2xl font-bold text-[#333333] mb-6">
          Privacy Policy for AfricFresh
        </h2>


        <div className="space-y-8 text-gray-700">
          {/* Introduction */}
          <p className="leading-relaxed">
            At AfricFresh, we value and respect your privacy. This Privacy Policy outlines how we collect, use, and protect your personal information when you visit our website or make purchases from our store. By using our services, you agree to the terms set forth in this policy.
          </p>

          {/* Policy Sections */}
          <section className="space-y-8">
            {/* Section 1 */}
            <div>
              <h3 className="text-xl font-bold text-[#333333] mb-3">1. Information We Collect</h3>
              <p className="leading-relaxed">
                We collect personal information such as your name, email address, shipping address, and payment details when you place an order. Additionally, we may collect information about your browsing behavior, device type, and location to improve your shopping experience.
              </p>
            </div>

            {/* Section 2 */}
            <div>
              <h3 className="text-xl font-bold text-[#333333] mb-3">2. How We Use Your Information</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Order Processing: To fulfill your orders, including shipping, billing, and customer support.</li>
                <li>Communication: To send order confirmations, updates, promotional offers (if you have opted in), and customer service inquiries.</li>
                <li>Improvement of Services: To analyze website traffic and improve user experience, content, and product offerings.</li>
              </ul>
            </div>

            {/* Section 3 */}
            <div>
              <h3 className="text-xl font-bold text-[#333333] mb-3">3. Data Security</h3>
              <p className="leading-relaxed">
                We implement robust security measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. Our payment processing system is secure, and we do not store sensitive payment information.
              </p>
            </div>

            {/* Section 4 */}
            <div>
              <h3 className="text-xl font-bold text-[#333333] mb-3">4. Sharing Your Information</h3>
              <p className="leading-relaxed">
                We do not sell, trade, or rent your personal information to third parties. However, we may share your information with trusted third-party partners, such as delivery services and payment processors, solely for the purpose of completing your order.
              </p>
            </div>

            {/* Section 5 */}
            <div>
              <h3 className="text-xl font-bold text-[#333333] mb-3">5. Cookies</h3>
              <p className="leading-relaxed">
                We use cookies to enhance your shopping experience. Cookies help us remember your preferences, provide personalized content, and analyze website traffic. You can adjust your browser settings to refuse cookies, but this may affect your user experience.
              </p>
            </div>

            {/* Section 6 */}
            <div>
              <h3 className="text-xl font-bold text-[#333333] mb-3">6. Your Rights</h3>
              <p className="leading-relaxed">
                You have the right to access, update, or delete your personal information by contacting us directly. If you have opted in to receive marketing communications, you can unsubscribe at any time by following the unsubscribe link in the email or contacting us.
              </p>
            </div>

            {/* Section 7 */}
            <div>
              <h3 className="text-xl font-bold text-[#333333] mb-3">7. Changes to This Privacy Policy</h3>
              <p className="leading-relaxed">
                We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date. We encourage you to review this Privacy Policy periodically to stay informed about how we protect your information.
              </p>
            </div>

            {/* Section 8 */}
            <div>
              <h3 className="text-xl font-bold text-[#333333] mb-3">8. Contact Us</h3>
              <p className="leading-relaxed">
                If you have any questions or concerns about our Privacy Policy or how we handle your personal information, please contact us at:
              </p>
              <div className="mt-3 pl-4">
                <p>Email: privacy@africfresh.com</p>
                <p>Phone: 1-800-AFRICFRESH</p>
                <p>Address: [Your Business Address]</p>
              </div>
            </div>

            {/* Closing Statement */}
            <div className="pt-6 border-t border-gray-200">
              <p className="font-medium">
                By using AfricFresh services, you acknowledge that you have read and understand this Privacy Policy and agree to its terms and conditions.
              </p>
             
            </div>
          </section>
        </div>
      </div>

      {/* Portal Icon */}
      <div className="fixed bottom-6 right-6 z-50">
        <div className="w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:shadow-xl transition-shadow cursor-pointer">
          <svg 
            className="w-8 h-8 text-[#007D44]" 
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 100 16 8 8 0 000-16z" />
          </svg>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;